export default "__VITE_ASSET__BlEdFi8r__"